var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanBarcode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 20.625C8.385 20.625 7.875 20.115 7.875 19.5V15.75C7.875 11.4 11.415 7.875 15.75 7.875H19.5C20.115 7.875 20.625 8.385 20.625 9C20.625 9.615 20.115 10.125 19.5 10.125H15.75C12.645 10.125 10.125 12.645 10.125 15.75V19.5C10.125 20.115 9.615 20.625 9 20.625Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 20.625C38.385 20.625 37.875 20.115 37.875 19.5V15.75C37.875 12.645 35.355 10.125 32.25 10.125H28.5C27.885 10.125 27.375 9.615 27.375 9C27.375 8.385 27.885 7.875 28.5 7.875H32.25C36.585 7.875 40.125 11.4 40.125 15.75V19.5C40.125 20.115 39.615 20.625 39 20.625Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 40.125H30C29.385 40.125 28.875 39.615 28.875 39C28.875 38.385 29.385 37.875 30 37.875H32.25C35.355 37.875 37.875 35.355 37.875 32.25V30C37.875 29.385 38.385 28.875 39 28.875C39.615 28.875 40.125 29.385 40.125 30V32.25C40.125 36.6 36.585 40.125 32.25 40.125Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 40.125H15.75C11.415 40.125 7.875 36.6 7.875 32.25V28.5C7.875 27.885 8.385 27.375 9 27.375C9.615 27.375 10.125 27.885 10.125 28.5V32.25C10.125 35.355 12.645 37.875 15.75 37.875H19.5C20.115 37.875 20.625 38.385 20.625 39C20.625 39.615 20.115 40.125 19.5 40.125Z",
    fill: "#111827"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13.875H16.5C14.79 13.875 13.875 14.775 13.875 16.5V19.5C13.875 21.225 14.79 22.125 16.5 22.125H19.5C21.21 22.125 22.125 21.225 22.125 19.5V16.5C22.125 14.775 21.21 13.875 19.5 13.875Z",
    fill: "#111827"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 13.875H28.5C26.79 13.875 25.875 14.775 25.875 16.5V19.5C25.875 21.225 26.79 22.125 28.5 22.125H31.5C33.21 22.125 34.125 21.225 34.125 19.5V16.5C34.125 14.775 33.21 13.875 31.5 13.875Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25.875H16.5C14.79 25.875 13.875 26.775 13.875 28.5V31.5C13.875 33.225 14.79 34.125 16.5 34.125H19.5C21.21 34.125 22.125 33.225 22.125 31.5V28.5C22.125 26.775 21.21 25.875 19.5 25.875Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 25.875H28.5C26.79 25.875 25.875 26.775 25.875 28.5V31.5C25.875 33.225 26.79 34.125 28.5 34.125H31.5C33.21 34.125 34.125 33.225 34.125 31.5V28.5C34.125 26.775 33.21 25.875 31.5 25.875Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanBarcode);
export default __webpack_public_path__ + "static/media/scanBarcode.3f9125693e5010d7a880863d0c3780b4.svg";
export { ForwardRef as ReactComponent };